// store/modules/common.js
import {getTransportation, getPlatform, getOrders} from "@/api/menu";
import {partitionType, queryPartType, queryStore} from "@/api/storeApi";
import {getFbaWarehouseOptions} from "@/api/wms/fbaWarehouseApi";
import {
    getActiveLogisticsProducts,
    getActiveLogisticsTemplatesList,
    getActiveShippingPartitionSchemes,
    getAllLogisticsChannels, getFeeTypeList,
    getLogisticsChannels,
    getLogisticsProducts,
    getLogisticsTemplates,
    getShippingPartitionSchemes
} from "@/api/api"; // 导入接口

const state = {
    transportMethodMap: new Map(), // 运输方式映射
    platformMap: new Map(), // 平台映射
    storeMap: new Map(), // 仓库类型映射
    orderMap: new Map(), // 订单类型映射
    logisticsChannelMap: new Map(), // 物流渠道映射
    logisticsProductMap: new Map(), // 物流产品映射
    LogisticsWeightTemplateMap: new Map(), // 物流重量模板映射
    ShippingPartitionSchemeMap: new Map(), // 运费分区方案映射
    FeeTypeMap: new Map(), // 运费类型映射
    transportationModeList: [], // 运输方式列表
    platformList: [] , // 平台列表
    partitionTypeList: [], // 分区类型列表
    storeList: [], // 仓库列表
    locationTypeList: [] ,// 库位类型列表
    orderList: [] ,// 订单列表
    logisticsChannelList: [], // 物流渠道列表
    logisticsProductList: [], // 物流产品列表
    LogisticsWeightTemplateList: [], // 物流重量模板列表
    ShippingPartitionSchemeList: [], // 运费分区方案列表
    FeeTypeList: [], // 运费类型列表
    fbaWarehouseList: [], // FBA仓列表
    fbaWarehouseMap: new Map(), // FBA仓映射
};

const mutations = {
    // 更新运输方式映射
    SET_TRANSPORT_MAP(state, { list, map }) {
        state.transportationModeList = list;
        state.transportMethodMap = map;
    },
    // 更新平台映射
    SET_PLATFORM_MAP(state, { list, map }) {
        state.platformList = list;
        state.platformMap = map;
    },
    // 新增：更新分区类型列表
    SET_PARTITION_TYPE(state, list) {
        state.partitionTypeList = list; // 将接口返回的列表存入state
    },
    // 新增：更新仓库列表
    SET_STORE_LIST(state, {list, map}) {
        state.storeList = list; // 将接口返回的列表存入state
        state.storeMap = map; // 将接口返回的映射存入state
    },
    //更新库位类型列表
    SET_LOCATION_TYPE(state, list) {
        state.locationTypeList = list; // 将接口返回的列表存入state
    },
    // 新增：更新订单列表
    SET_ORDER_LIST(state, {list, map}) {
        state.orderList = list; // 将接口返回的列表存入state
        state.orderMap = map; // 将接口返回的映射存入state
    },
    // 新增：更新物流渠道列表
    SET_LOGISTICS_CHANNEL_LIST(state, {list, map}) {
        state.logisticsChannelList = list; // 将接口返回的列表存入state
        state.logisticsChannelMap = map; // 将接口返回的映射存入state
    },
    // 新增：更新物流产品列表
    SET_LOGISTICS_PRODUCT_LIST(state, {list, map}) {
        state.logisticsProductList = list; // 将接口返回的列表存入state
        state.logisticsProductMap = map; // 将接口返回的映射存入state
    },
    // 新增：更新物流重量模板列表
    SET_LOGISTICS_WEIGHT_TEMPLATE_LIST(state, {list, map}) {
        state.LogisticsWeightTemplateList = list; // 将接口返回的列表存入state
        state.LogisticsWeightTemplateMap = map; // 将接口返回的映射存入state
    },
    // 新增：更新运费分区方案列表
    SET_SHIPPING_PARTITION_SCHEME_LIST(state, {list, map}) {
        state.ShippingPartitionSchemeList = list; // 将接口返回的列表存入state
        state.ShippingPartitionSchemeMap = map; // 将接口返回的映射存入state
    },
    // 新增：更新运费类型列表
    SET_FEE_TYPE_LIST(state, {list,map}) {
        state.FeeTypeList = list; // 将接口返回的列表存入state
        state.FeeTypeMap = map; // 将接口返回的映射存入state
    },
    // 新增：更新FBA仓列表
    SET_FBA_WAREHOUSE_LIST(state, {list,map}) {
        state.fbaWarehouseList = list; // 将接口返回的列表存入state
        state.fbaWarehouseMap = map; // 将接口返回的映射存入state
    },
};

const actions = {
    // 加载运输方式并构建映射（使用then方式）
    loadTransportation({ commit }) {
        // 返回Promise，方便组件处理后续逻辑
        return getTransportation()
            .then(response => {
                const list = response.data || [];
                const map = new Map();
                list.forEach(item => {
                    map.set(Number(item.id), item.transportName); // 确保id为数字
                });
                commit('SET_TRANSPORT_MAP', { list, map });
                return list; // 允许组件获取加载的列表
            })
            .catch(error => {
                console.error('加载运输方式失败:', error);
                throw error; // 抛出错误，允许组件捕获
            });
    },

    // 加载平台并构建映射（使用then方式，与你习惯的写法一致）
    loadPlatform({ commit }) {
        return getPlatform()
            .then(response => {
                // 与你提供的代码逻辑保持一致
                const platformList = response.data || [];
                const platformMap = new Map();

                platformMap.clear(); // 清空旧数据
                platformList.forEach(item => {
                    platformMap.set(Number(item.id), item.platformName); // key: ID（数字）, value: 中文名称
                });

                // 提交mutation更新状态
                commit('SET_PLATFORM_MAP', {
                    list: platformList,
                    map: platformMap
                });

                return platformList; // 可选：返回数据给调用者
            })
            .catch(error => {
                console.error(error);
                throw error; // 允许组件捕获错误
            });
    },
    loadPartitionType({ commit }){
        return partitionType()
            .then(response => {
                const partitionTypeList = response.data || [];
                commit('SET_PARTITION_TYPE', partitionTypeList); // 提交mutation更新状态
                return partitionTypeList; // 返回列表给调用者（可选）
            })
            .catch(error => {
                console.error('加载分区类型失败:', error);
                throw error; // 抛出错误，允许组件捕获
            });
    },
    loadStore({ commit }){
        const  qStore={

        }
        return queryStore(qStore)
           .then(response => {
                const allStoreList = response.data || [];
                // storeMap 保留所有仓库，用于回显
                const storeMap = new Map();
                allStoreList.forEach(item => {
                    storeMap.set(Number(item.sId), item.sName);
                });
                // storeList 只保留标准仓库，用于下拉选择
                const storeList = allStoreList.filter(item => item.sType === '标准');
                commit('SET_STORE_LIST', {
                    list: storeList,
                    map: storeMap
                });
                return storeList;
            })
           .catch(error => {
                console.error('加载仓库列表失败:', error);
                throw error;
            });
    },
    loadLocationType({ commit }){
        const  qStore={
            sStoreType: 2,
        }
        return queryPartType(qStore)
            .then(response => {
                const locationTypeList = response.data || [];
                commit('SET_LOCATION_TYPE', locationTypeList); // 提交mutation更新状态
                return locationTypeList; // 返回列表给调用者（可选）
            })
            .catch(error => {
                console.error('加载库位类型列表失败:', error);
                throw error; // 抛出错误，允许组件捕获
            });
    },
    loadOrderList({ commit }){
        return getOrders()
           .then(response => {
                const orderList = response.data || [];
                const orderMap = new Map();
                orderMap.clear(); // 清空旧数据
                orderList.forEach(item => {
                    orderMap.set(Number(item.id), item.orderNo); // key: ID（数字）, value: 中文名称
                });
                commit('SET_ORDER_LIST', {
                    list: orderList,
                    map: orderMap
                }); // 提交mutation更新状态
                return orderList; // 返回列表给调用者（可选）
            })
            .catch(error => {
                console.error('加载订单列表失败:', error);
                throw error; // 抛出错误，允许组件捕获
            });
    },
       loadLogisticsChannel({ commit }){
        return getAllLogisticsChannels()
            .then(response => {
                const logisticsChannelList = response.data || [];
                const logisticsChannelMap = new Map();
                logisticsChannelMap.clear(); // 清空旧数据
                logisticsChannelList.forEach(item => {
                    logisticsChannelMap.set(Number(item.channelId), item.channelCn); // key: ID（数字）, value: 中文名称
                });
                commit('SET_LOGISTICS_CHANNEL_LIST', {
                    list: logisticsChannelList,
                    map: logisticsChannelMap
                }); // 提交mutation更新状态
                return logisticsChannelList; // 返回列表给调用者（可选）
            })
            .catch(error => {
                console.error('加载物流渠道列表失败:', error);
                throw error; // 抛出错误，允许组件捕获
            });
    },
    loadLogisticsProduct({ commit }){
        return getActiveLogisticsProducts()
            .then(response => {
                const logisticsProductList = response.data || [];
                const logisticsProductMap = new Map();
                logisticsProductMap.clear(); // 清空旧数据
                logisticsProductList.forEach(item => {
                    logisticsProductMap.set(Number(item.logisticsProductId), item.productNameCn); // key: ID（数字）, value: 中文名称
                });
                commit('SET_LOGISTICS_PRODUCT_LIST', {
                    list: logisticsProductList,
                    map: logisticsProductMap
                }); // 提交mutation更新状态
                return logisticsProductList; // 返回列表给调用者（可选）
            })
            .catch(error => {
                console.error('加载物流产品列表失败:', error);
                throw error; // 抛出错误，允许组件捕获
            });
        },
    loadLogisticsWeightTemplate({ commit }){
       /* const queryParams = {
            status: 1,
        };*/
        return getActiveLogisticsTemplatesList()
            .then(response => {
                const LogisticsWeightTemplateList = response.data || [];
                const LogisticsWeightTemplateMap = new Map();
                LogisticsWeightTemplateMap.clear(); // 清空旧数据
                LogisticsWeightTemplateList.forEach(item => {
                    LogisticsWeightTemplateMap.set(Number(item.logisticsTemplateId), item.templateCnName); // key: ID（数字）, value: 中文名称
                });
                commit('SET_LOGISTICS_WEIGHT_TEMPLATE_LIST', {
                    list: LogisticsWeightTemplateList,
                    map: LogisticsWeightTemplateMap
                }); // 提交mutation更新状态
                return LogisticsWeightTemplateList; // 返回列表给调用者（可选）
            })
            .catch(error => {
                console.error('加载物流重量模板列表失败:', error);
                throw error; // 抛出错误，允许组件捕获
            });
    },
    loadShippingPartitionScheme({ commit }){
     /*   const queryParams = {
            status: 1,
        };*/
        return getActiveShippingPartitionSchemes()
            .then(response => {
                const ShippingPartitionSchemeList = response.data || [];
                const ShippingPartitionSchemeMap = new Map();
                ShippingPartitionSchemeMap.clear(); // 清空旧数据
                ShippingPartitionSchemeList.forEach(item => {
                    ShippingPartitionSchemeMap.set(Number(item.schemeId), item.schemeName); // key: ID（数字）, value: 中文名称
                });
                commit('SET_SHIPPING_PARTITION_SCHEME_LIST', {
                    list: ShippingPartitionSchemeList,
                    map: ShippingPartitionSchemeMap
                }); // 提交mutation更新状态
                return ShippingPartitionSchemeList; // 返回列表给调用者（可选）
            })
            .catch(error => {
                console.error('加载运费分区方案列表失败:', error);
                throw error; // 抛出错误，允许组件捕获
            });
    },
    loadFeeType({ commit }){
        return getFeeTypeList()
            .then(response => {
                const FeeTypeList = response.data.records || [];
                const FeeTypeMap = new Map();
                FeeTypeMap.clear(); // 清空旧数据
                FeeTypeList.forEach(item => {
                    FeeTypeMap.set(Number(item.id), item.nameCn); // key: ID（数字）, value: 中文名称
                });
                commit('SET_FEE_TYPE_LIST', {
                    list: FeeTypeList,
                    map: FeeTypeMap
                }); // 提交mutation更新状态
                return FeeTypeList; // 返回列表给调用者（可选）
            })
            .catch(error => {
                console.error('加载运费类型列表失败:', error);
                throw error; // 抛出错误，允许组件捕获
            });
    },
    loadFbaWarehouse({ commit }){
        return getFbaWarehouseOptions()
            .then(response => {
                const fbaWarehouseList = response.data || [];
                const fbaWarehouseMap = new Map();
                fbaWarehouseMap.clear(); // 清空旧数据
                fbaWarehouseList.forEach(item => {
                    fbaWarehouseMap.set(Number(item.id), item.fbaName); // key: ID（数字）, value: FBA名称
                });
                commit('SET_FBA_WAREHOUSE_LIST', {
                    list: fbaWarehouseList,
                    map: fbaWarehouseMap
                }); // 提交mutation更新状态
                return fbaWarehouseList; // 返回列表给调用者（可选）
            })
            .catch(error => {
                console.error('加载FBA仓列表失败:', error);
                throw error; // 抛出错误，允许组件捕获
            });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
